import type { ReactElement } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import { RadioInput } from '@hivebrite/design-system/Inputs';

export interface RadiosInputProps {
  direction: 'vertical' | 'horizontal';
  name: string;
  onBlur?: () => void;
  onChange: (value: string) => void;
  onFocus?: () => void;
  options: Array<{
    label: string;
    value: string;
    description?: string | ReactElement;
  }>;
  value: string;
}

const RadiosInput = ({
  direction,
  name,
  onBlur,
  onChange,
  onFocus,
  options,
  value: selectedValue,
}: RadiosInputProps) => (
  <Box flexDirection={direction === 'vertical' ? 'column' : 'row'} width="100%">
    {options.map(({ label, value, description }, index) => {
      const isFirst = index === 0;
      const isLast = index === options.length - 1;

      return (
        <Box
          alignItems="flex-start"
          key={value}
          {...(!isLast && direction === 'vertical' && { mb: 4 })}
          {...(!isFirst && direction === 'horizontal' && { ml: 6 })}
        >
          <div>
            <RadioInput
              checked={value === selectedValue}
              label={label}
              onChange={() => onChange(value)}
              onBlur={onBlur}
              onFocus={onFocus}
              value={value}
              id={`${name}-${value}`}
              name={name}
              type="radio"
            />
            {description && (
              <Box mt={2} ml="26px" color="dove">
                {description}
              </Box>
            )}
          </div>
        </Box>
      );
    })}
  </Box>
);

export default RadiosInput;
